import { Box, Typography } from '@mui/material';
import { useApiUrl, useCustom } from '@refinedev/core';
import { useMemo } from 'react';
import { useParams } from 'react-router';
import { OrganizationWithAccountsAndMagazines } from '../../types/account.ts';

export function Dashboard() {
  const { organizationId } = useParams<{ organizationId: string }>();

  const API_URL = useApiUrl();

  const { data: _data } = useCustom<OrganizationWithAccountsAndMagazines>({
    url: `${API_URL}/organization/${organizationId}/dashboard`,
    method: 'get',
    config: {},
    queryOptions: {
      queryKey: ['dashboard'],
      enabled: true,
    },
  });

  const data = useMemo(
    () => (_data?.data ? OrganizationWithAccountsAndMagazines.parse(_data?.data) : undefined),
    [_data?.data],
  );

  if (!data) {
    return null;
  }

  return (
    <Box sx={{ m: 2 }}>
      <Box sx={{ mb: 2 }}>
        <Typography color="text.secondary" variant="subtitle2">
          利用ユーザー数
        </Typography>
        <Typography variant="subtitle2" component="p" sx={{ textAlign: 'right' }}>
          {data.accounts.filter((account) => account.status === 'active').length}/
          {data.accountLimitNum}
        </Typography>
      </Box>

      <Box sx={{ mb: 2 }}>
        <Typography color="text.secondary" variant="subtitle2">
          NBL利用数
        </Typography>
        <Typography variant="subtitle2" component="p" sx={{ textAlign: 'right' }}>
          {data.magazines.nbl?.accountCount ?? '-'}/{data.magazines.nbl?.accountLimitNum ?? '-'}
        </Typography>
      </Box>

      <Box sx={{ mb: 2 }}>
        <Typography color="text.secondary" variant="subtitle2">
          資料版商事法務利用数
        </Typography>
        <Typography variant="subtitle2" component="p" sx={{ textAlign: 'right' }}>
          {data.magazines.shiryoban?.accountCount ?? '-'}/
          {data.magazines.shiryoban?.accountLimitNum ?? '-'}
        </Typography>
      </Box>

      <Box>
        <Typography color="text.secondary" variant="subtitle2">
          旬刊商事法務利用数
        </Typography>
        <Typography variant="subtitle2" component="p" sx={{ textAlign: 'right' }}>
          {data.magazines.junkan?.accountCount ?? '-'}/
          {data.magazines.junkan?.accountLimitNum ?? '-'}
        </Typography>
      </Box>
    </Box>
  );
}
